function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M25.058-35.821a14.936 14.936 0 0 0-20.724 0 14.042 14.042 0 0 0-.894 19.35l10.242 12A1.333 1.333 0 0 0 14.7-4a1.334 1.334 0 0 0 1.013-.467l10.242-12a14.043 14.043 0 0 0-.897-19.354zM14.7-17.337a8 8 0 0 1-8-8 8 8 0 0 1 8-8 8 8 0 0 1 8 8 8 8 0 0 1-2.343 5.657 8 8 0 0 1-5.657 2.343zM28.033 0H1.361A1.375 1.375 0 0 1 .306-.514a1.375 1.375 0 0 1-.278-1.139l2.667-10.67a1.372 1.372 0 0 1 .942-1.012 1.372 1.372 0 0 1 1.345.323 1.372 1.372 0 0 1 .38 1.33L3.068-2.668h23.258l-2.294-9.015a1.371 1.371 0 0 1 .38-1.33 1.372 1.372 0 0 1 1.345-.323 1.372 1.372 0 0 1 .942 1.012l2.667 10.67a1.325 1.325 0 0 1-.254 1.159A1.324 1.324 0 0 1 28.033 0z",
  transform: "translate(0 40)"
});

var SvgContactLocation = function SvgContactLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.408,
    height: 39.998,
    viewBox: "0 0 29.408 39.998",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact_location.cf0d5484.svg";
export { ForwardRef as ReactComponent };